import * as raygun from './vendor/raygun';

/**
 * Initialise JustGiving error logger
 */
export const initErrorLogger = (APP_VERSION, APP_NAME, hasInit = false) => {
	raygun.init(APP_VERSION, APP_NAME, hasInit);
};

/**
 * Use this method to log handled exceptions in the app.
 * @param {error} error - an instance of the Error class
 * @param {object} vendorLogger - allows unit tests to mock
 */
export const logError = (error, vendorLogger = raygun) => {
	if (error.response) {
		let customData = {};
		customData.httpStatus = error.response.status || '';
		customData.url = error.response.url || '';
		// you can only read the response json once, so we need
		// to check 'response.bodyUsed' to avoid an exception...
		if (!error.response.bodyUsed) {
			error.response.json().then(data => {
				customData.json = data || '';
				vendorLogger.logError(error, customData);
			});
		} else {
			vendorLogger.logError(error, customData);
		}
	} else {
		vendorLogger.logError(error);
	}
};



// WEBPACK FOOTER //
// ../~/dna-core/components/utils/js/errors.js